import React, { useContext } from 'react'

import { Flex, Box, Text, Button } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import UserCard from './components/UserCard/UserCard'
import UserForm from './components/UserForm/UserForm'
import { DislikeIcon, FavoriteIcon } from './assets'

import Badges from './components/Badges/Badges'
import Community from './components/Community/Community'
import { ThemeContext } from 'styled-components'
import { TutorProfileType } from './types/index'
import ProfileIncomplete from './components/ProfileIncomplete/ProfileIncomplete'

// bad way to circument type checking on aaron button, width, disabled and css props work but are missing form type
const CustomButton: any = Button

const TutorProfile: React.FC<TutorProfileType> = ({
  currentUser,

  handleUpdateUserTutor,
  handleUpdateUser,
  handleFileChange,
  handleTextChange,

  onEdit,
  onCancel,

  isFavorite,
  isBlocked,
  isEditing,

  login,
  community,
  tutor,
  fluentLanguages,
  location,
  name,
  profile,
  avatarUrl,
}) => {
  const {
    colors: {
      gray60,
      gray46,
      gray80,
      gray95,
      pink51,
      pink30,
      pink97,
      white100,
      black19,
    },
  } = useContext(ThemeContext)

  const getBlockButtonColor = () => {
    return isFavorite ? gray60 : !isBlocked ? white100 : gray46
  }

  const countOfCompletedLiveLessons = tutor?.countOfCompletedLiveLessons
  const isCurrentUser = currentUser?.login === login
  const currentAvatarUrl = avatarUrl || profile?.avatarUrl

  if (!community?.aboutMe) {
    return (
      <Flex
        bg="white100"
        p={{ _: '3x', tablet: '6x' }}
        boxShadow="raised"
        borderRadius="1x"
        flexDirection="column"
      >
        <ProfileIncomplete login={login} isCurrentUser={isCurrentUser} />
      </Flex>
    )
  }

  return (
    <Flex
      bg="white100"
      p={{ _: '3x', tablet: '6x' }}
      boxShadow="raised"
      borderRadius="1x"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="top"
      css={`
        font-weight: 100;
      `}
    >
      {!isEditing && (
        <UserCard
          name={name}
          login={login}
          location={location}
          avatarUrl={currentAvatarUrl}
          // pass in 0 as fallback, props destructure in UserCard with default val 0 doesn't work if value is null
          liveLessonCount={countOfCompletedLiveLessons}
          approvedLanguages={tutor?.approvedLanguages}
          fluentLanguages={fluentLanguages}
        />
      )}
      {isEditing && (
        <UserForm
          name={name}
          login={login}
          location={location}
          avatarUrl={currentAvatarUrl}
          onTextChange={handleTextChange}
          onFileChange={handleFileChange}
        />
      )}
      {/* one x less for mt because UserCard last element `LanguageIconsWithText` contains mb 1x */}
      <Box
        mt={currentUser ? { _: '2x', tablet: '4x' } : '1x'}
        mb="2x"
        borderBottom="1px solid #DEE0E3"
      ></Box>
      <Flex
        flexDirection={{ _: 'column', mobile: 'row' }}
        justifyContent="center"
        alignItems="baseline"
      >
        {isCurrentUser && !isEditing && (
          <Box width={{ _: '100%', mobile: 'auto' }}>
            <CustomButton
              width="100%"
              type="danger"
              size="large"
              onClick={() => {
                onEdit()
              }}
            >
              {t('Edit my profile')}
            </CustomButton>
          </Box>
        )}
        {isCurrentUser && isEditing && (
          <Flex mr="1x">
            <Button
              type="success"
              size="large"
              onClick={handleUpdateUser}
              disableWith={t('Saving...')}
            >
              {t('Save changes')}
            </Button>
          </Flex>
        )}
        {isCurrentUser && isEditing && (
          <Button
            type="danger"
            size="large"
            fill="outline"
            onClick={(e) => {
              onCancel()
            }}
          >
            {t('Cancel')}
          </Button>
        )}
        {tutor && currentUser && !isCurrentUser && (
          <Box
            mr={{ _: null, mobile: '2x' }}
            mb={{ _: '2x', mobile: 0 }}
            width={{ _: '100%', mobile: 'auto' }}
          >
            <CustomButton
              width="100%"
              disabled={isBlocked}
              // cant really change `color`, eg. text color, so have to use css prop
              css={`
                font-weight: 400 !important;
                color: ${isBlocked ? gray60 : null};
                background-color: ${isBlocked
                  ? gray80 + ' !important'
                  : !isFavorite
                  ? pink51
                  : white100};
                border-color: ${!isFavorite ? null : pink51};
                &:hover {
                  // blocked color state
                  color: ${isBlocked
                    ? gray60
                    : !isFavorite
                    ? white100
                    : pink51};
                  // favorite color state
                  background-color: ${!isFavorite ? pink30 : pink97};
                  border-color: ${!isFavorite ? null : pink51};
                }
              `}
              type={isBlocked ? 'primaryAdvanced' : 'ctaAdvanced'}
              size="large"
              fill={isFavorite ? 'outline' : 'solid'}
              onClick={() => {
                handleUpdateUserTutor({
                  isFavorite: !isFavorite,
                  isBlocked: isBlocked,
                })
              }}
            >
              <Flex alignItems="center" justifyContent="center">
                <FavoriteIcon
                  fill={pink51}
                  transparent={!isFavorite}
                  outline={!isBlocked ? white100 : gray60}
                />
                <Text fontSize="sm" ml="0,5x">
                  {isFavorite ? t('Unfavorite') : t('Favorite')}
                </Text>
              </Flex>
            </CustomButton>
          </Box>
        )}

        {currentUser && !isCurrentUser && (
          <Flex alignSelf="center" width={{ _: '100%', mobile: 'auto' }}>
            <CustomButton
              disabled={isFavorite}
              css={`
                font-weight: 400 !important;
                background-color: ${isFavorite
                  ? gray80 + ' !important'
                  : !isBlocked
                  ? gray46
                  : white100};
                border-color: ${gray46};
                color: ${getBlockButtonColor()};
                &:hover {
                  background-color: ${!isBlocked ? black19 : gray95};
                  color: ${getBlockButtonColor()};
                }
              `}
              title={
                isBlocked
                  ? t('Allow scheduling Live Lessons with this tutor')
                  : t('Prevent scheduling any Live Lessons with this tutor')
              }
              onClick={() => {
                handleUpdateUserTutor({
                  isBlocked: !isBlocked,
                  isFavorite: isFavorite,
                })
              }}
              width="100%"
              size="large"
              fill={isBlocked ? 'outline' : 'solid'}
            >
              <Flex alignItems="center" justifyContent="center">
                <DislikeIcon
                  outline={isFavorite ? gray60 : isBlocked ? gray46 : white100}
                  fill={gray46}
                  transparent={!isBlocked || isFavorite}
                />
                <Text fontSize="sm" ml="0,5x">
                  {isBlocked ? t('Unblock') : t('Block')}
                </Text>
              </Flex>
            </CustomButton>
          </Flex>
        )}
      </Flex>
      {currentUser && (
        <Box mb="3x" mt="2x" borderBottom="1px solid #DEE0E3"></Box>
      )}
      <Flex flexDirection="column" alignItems="center">
        {isBlocked ? (
          <Text>
            {t(
              'This tutor is currently blocked. Any requested Live Lessons will not be available to this tutor. To start having lessons again with this tutor, you can simply use the unblock button.'
            )}
          </Text>
        ) : (
          <Community
            login={login}
            isCurrentUser={isCurrentUser}
            community={community || {}}
          />
        )}
      </Flex>
      {!isBlocked && (
        <>
          {(community?.badges?.length > 0 ||
            community?.recentDiscussions?.length > 0) && (
            <Box mb="3x" mt="3x" borderBottom="1px solid #DEE0E3"></Box>
          )}
          <Badges
            login={login}
            isCurrentUser={isCurrentUser}
            badges={community?.badges || []}
          />
        </>
      )}
    </Flex>
  )
}

export default TutorProfile
